import Button from "components/Button/Button";
import RankChart from "components/RankChart/RankChart";
import salesData from 'mock/mockSales.json';
import React from "react";
import SalesModal from "./components/SalesModal/SalesModal";


interface ISales {}
const Sales: React.FC<ISales> = () => {

  const [isPositiveDelta, setIsPositiveDelta] = React.useState(true);
  const [modalOpen, setModalOpen] = React.useState(false);

  const toggleModalOpen = () => {
    setModalOpen(!modalOpen);
  }
  
  const onRowClick =(e:any) => {
    setModalOpen(true);
  }

  const CustomHeader = () => {
    return(
      <>
        <Button 
          onClick={() => setIsPositiveDelta(true)} type={isPositiveDelta? 'primary' : 'secondary'}>POSITIVE DELTA</Button>
        <Button 
          onClick={() => setIsPositiveDelta(false)} type={isPositiveDelta? 'secondary' : 'primary'}>NEGATIVE DELTA</Button>
      </>
    )
  }

  const SubHeader = () => {
    return <p>These are you <b>increasing</b> accounts from October 1, 2022 to September 30, 2024 (24m):</p>
  }

  return(
    <div style={{paddingTop: '10vh'}}>
      <RankChart 
        headerTitle="Customer List"
        onRowClick={onRowClick}
        customHeader={CustomHeader()} 
        subHeader={SubHeader()}
        columns={[]} data={salesData} isLoading={false}  />

      <SalesModal
        handleClose={toggleModalOpen} 
        isOpen={modalOpen}></SalesModal>
    </div>
  )
}

export default Sales;